import { memo } from "react";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { type GridColumnType } from "commonComponents/utilities/Grid/GridContainer.types";
import ReadMore from "commonComponents/utilities/ReadMore/ReadMore";

interface IUnimplementedCellProps {
    cellValue: any | undefined;
    column: { columnType: GridColumnType };
}

export const BTUnimplementedCell = memo<IUnimplementedCellProps>(function UnimplementedCell({
    column,
    cellValue,
}) {
    return (
        <ReadMore numberOfLines={3}>
            <BTAlert
                style={{ maxHeight: "100px" }}
                message={`Unimplemented GridColumnType columnType:'${
                    column.columnType
                }', value:${JSON.stringify(cellValue)}`}
                type="error"
                data-testid="UnimplementedGridColumnType"
            />
        </ReadMore>
    );
});
